"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createDebugger = exports.enableDebugger = void 0;
var debug_1 = __importDefault(require("debug"));
debug_1["default"].formatters.h = function (v) {
    return v.toString("hex");
};
var enableDebugger = function (namespace) {
    global.logging = true;
    process.env.DEBUG = "".concat(namespace, "*");
    debug_1["default"].enable(namespace);
    if (typeof window !== "undefined") {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("debug", "".concat(namespace, "*"));
        }
    }
};
exports.enableDebugger = enableDebugger;
var createDebugger = function (namespace, logging) {
    namespace = "kenai:".concat(namespace);
    if (logging || global.logging) {
        (0, exports.enableDebugger)(namespace);
    }
    var debug = (0, debug_1["default"])(namespace);
    debug.enable = function () {
        (0, exports.enableDebugger)(namespace);
    };
    debug.disable = function () {
        debug_1["default"].disable();
    };
    return debug;
};
exports.createDebugger = createDebugger;
exports["default"] = exports.createDebugger;
